export default __webpack_public_path__ + "ca26831cb62d5a56b9a5bec5d5c3b8ce.png";